import ContentContainer from "components/ContentContainer";
import FullPageContainer from "components/FullPageContainer";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const StyledFullPageContainer = styled(FullPageContainer)`
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.lightest} 66%,
    ${({ theme }) => theme.colors.secondary} 34%
  );

  @media (max-width: ${breakpoints.lg}) {
    background: unset;
    background-color: ${({ theme }) => theme.colors.lightest};
  }

  .login-animation {
    position: absolute;
    box-sizing: border-box;
    padding: 100px 0;
    width: 50vw;
    top: 0;
    right: 4vw;
    height: 100vh;

    @media (max-width: ${breakpoints.lg}) {
      display: none;
    }
  }
`;

export const StyledContentContainer = styled(ContentContainer)`
  box-sizing: border-box;
  width: 80%;
  margin-top: 80px;
  justify-content: flex-start;
`;

export const FormContainer = styled.div`
  padding-bottom: 100px;

  @media (min-width: ${breakpoints.lg}) {
    width: 50%;
    max-width: 420px;
  }
`;
